import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationPendingSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6.576 35.942a25.688 25.688 0 0 0 2.821 7.001c7.245 12.381 23.29 16.623 35.838 9.475 12.548-7.148 16.847-22.98 9.602-35.361C47.593 4.676 31.547.434 19 7.582a26.32 26.32 0 0 0-4.512 3.24",
            stroke: "#FDC221",
            strokeWidth: 4.11,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M31.233 19.726v15.617h9.863",
            stroke: "#FDC221",
            strokeWidth: 4.11,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.857 35.5a1.166 1.166 0 0 1-1.56.638l-5.684-2.534a1.272 1.272 0 0 1-.665-1.63 1.166 1.166 0 0 1 1.56-.636l5.684 2.534c.622.277.915.995.665 1.629Z",
            fill: "#FDC221"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m6.609 32.958-2.873 5.57a1.33 1.33 0 0 1-1.831.551 1.422 1.422 0 0 1-.57-1.893l2.873-5.57a1.33 1.33 0 0 1 1.83-.551 1.42 1.42 0 0 1 .57 1.893Z",
            fill: "#FDC221"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h60v60H0z" }) }) })
    ]
  }
);
export {
  IllustrationPendingSvg
};
